export function useAttributeTranslations() {
  const { locale } = useI18n();
  const productStore = useProductStore();
  const translations = ref<Record<string, string>>({});

  async function fetchTranslations() {
      const cacheKey = `product_attribute_translations_${locale.value}`;

      try {
          // Try to get translations from productStore state
          if (productStore.attributeTranslations[cacheKey]){
              translations.value = productStore.attributeTranslations[cacheKey];
              return;
          }

          const runtimeConfig = useRuntimeConfig();
          // Fetch translations from the CDN if not found in productStore
          const baseUrl = runtimeConfig.public.translationCdnUrl;
          const response = await fetch(`${baseUrl}/attributes/${locale.value}.json`);

          if (!response.ok) throw new Error("Failed to load translations");

          let data;
            try {
                data = await response.json();
            } catch (jsonError) {
                const text = await response.text();
                throw new Error("Translation response is not valid JSON");
            }
          translations.value = data;

          // Store translations in productStore state
          productStore.setAttributeTranslations(cacheKey, data);
      } catch (error) {
        const {customClientErrorHandler} = await import("~/services-optimized/customErrorService");
        let errorMeta = { cacheKey,locale: locale.value }
        customClientErrorHandler(
            error,
            'high',
            'Attribute Translation Error - Failed to fetch translations',
            errorMeta
        );
      }
  }

  const stopLanguageWatcher = watch(locale, fetchTranslations, { immediate: true });

  onUnmounted(() => {
      stopLanguageWatcher();
  });

  return { translations, fetchTranslations };
}
